import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
import { SectionCTA } from './SectionCTA';
const faqs = [{
  question: '¿Necesito seguidores?',
  answer: 'No. Solo necesitas una oferta clara. El programa te enseña a vender sin depender de una audiencia masiva.'
}, {
  question: '¿Necesito saber grabar videos?',
  answer: 'No. Te enseñamos una estructura simple que no requiere equipos costosos ni habilidades avanzadas de edición.'
}, {
  question: '¿Cuánto tiempo diario necesito?',
  answer: 'Entre 60 y 90 minutos al día es suficiente para completar el programa en 15 días.'
}, {
  question: '¿Funciona en cualquier país?',
  answer: 'Sí, el sistema es aplicable globalmente siempre que tengas acceso a internet y redes sociales.'
}, {
  question: '¿Qué tipo de productos puedo crear?',
  answer: 'Programas, guías, ebooks, retos, mini cursos, mentorías y más. Te ayudamos a elegir el mejor formato para ti.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 bg-[#050510]" data-id="element-123">
      <div className="container mx-auto max-w-3xl" data-id="element-124">
        <ScrollReveal className="text-center mb-12" data-id="element-125">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-126">
            Preguntas Frecuentes
          </h2>
        </ScrollReveal>

        <div className="space-y-4" data-id="element-127">
          {faqs.map((faq, index) => <ScrollReveal key={index} delay={index * 0.1} data-id="element-128">
              <div className="glass-card rounded-xl overflow-hidden border border-white/5" data-id="element-129">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full p-6 flex items-center justify-between text-left hover:bg-white/5 transition-colors" data-id="element-130">
                  <span className="font-bold text-lg text-white" data-id="element-131">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-132" />
                </button>
                <AnimatePresence data-id="element-133">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-134">
                      <div className="p-6 pt-0 text-gray-400 border-t border-white/5" data-id="element-135">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </ScrollReveal>)}
        </div>

        <SectionCTA headline="¿Listo para dar el paso?" buttonText="QUIERO MONETIZAR MIS REDES — $16.39" data-id="element-136" />
      </div>
    </section>;
}